<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="sapBoms"
        @select="selectHandle"
        @reset="resetHandle"
    >
      <!--      <template slot="otherBtn">-->
      <!--        <el-button v-if="limits.cancelAuth" type="primary" :disabled="!selection.length" @click="approveHandle"> 审核 </el-button>-->
      <!--        <el-button v-if="limits.cancelAuth" type="primary" :disabled="!selection.length" @click="cancelHandle"> 作废 </el-button>-->
      <!--      </template>-->
      <template slot="actionBtn" slot-scope="scope">
        <el-button v-if="limits.setAuth" type="primary" @click="$refs.bomEdit.open(scope.row,false)">组件设置</el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable/>
          </el-form-item>
          <el-form-item label="审核状态">
            <el-select v-model="filter.status" placeholder="请选择审核状态" clearable>
              <el-option label="待审核" :value="10"/>
              <el-option label="已审核" :value="20"/>
              <el-option label="作废" :value="99"/>
            </el-select>
          </el-form-item>
          <el-form-item label="BOM类型">
            <el-select v-model="filter.bomType" placeholder="请选择BOM类型" clearable>
              <el-option label="销售BOM" :value="10"/>
              <el-option label="生产BOM" :value="20"/>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <bom-edit ref="bomEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import BomEdit from "./BomEdit";
  export default {
    name: "BomList",
    components: { viewTable, BomEdit },
    data() {
      return {
        limits: {
          setAuth: this.$auth(651),
        },
        filter: {
          materialNo: "",
          materialName: "",
          status: "",
          bomType: "",
        },
        selection: [],
        ids: [],
        columnsProperty: [
          {
            key: "bomNo",
            width: 200,
          },
          {
            key: "bomTypeName",
            width: 100,
            align: "center",
          },
          {
            key: "materialNo",
            width: 160,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.bomEdit.open(params.row, true);
                    },
                  },
                },
                params.row.materialNo
              );
            },
          },
          {
            key: "materialName",
            minWidth: 360,
          },
          {
            key: "versionNo",
            width: 80,
            align: "center",
          },
          {
            key: "statusName",
            width: 90,
            align: "center",
          },
          {
            key: "creatorName",
            width: 100,
            align: "center",
          },
          {
            key: "createTime",
            width: 160,
            align: "center",
          },
          {
            key: "approverName",
            width: 100,
            align: "center",
          },
          {
            key: "approveTime",
            width: 160,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.bomEdit.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      deleteHandle(row) {
        this.$http.delete("basic", "boms", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      selectHandle(selection) {
        this.selection = selection;
        this.ids = [];
        this.selection.forEach((item) => {
          this.ids.push(item.pkid);
        });
      },

      approveHandle() {
        const arr = this.selection.filter((item) => item.status !== 10);
        if (arr.length) {
          this.$confirm("请选择待审核的数据", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$confirm("确定审核通过吗?", "提示", { type: "warning" }).then(() => {
            this.$http.post("basic", "boms/approve", this.ids).then((resp) => {
              if (resp.success) {
                this.$message.success("审核成功");
                this.loadData();
                this.selection = [];
              }
            });
          });
        }
      },

      cancelHandle() {
        this.$confirm("确定作废吗?", "提示", { type: "warning" }).then(() => {
          this.$http.post("basic", "boms/abort", this.ids).then((resp) => {
            if (resp.success) {
              this.$message.success("作废成功");
              this.loadData();
              this.selection = [];
            }
          });
        });
      },

      resetHandle(filter) {
        this.filter = filter;
      },
    },
  };
</script>
